module.exports = {"attributes":{"viewBox":"0 0 10 11"},"content":"<g fill=\"#0084FF\" fill-rule=\"evenodd\">     <path d=\"M9.7 2.3A1 1 0 0 0 9 2H3.4c-.2 0-.4.2-.4.4s.2.3.4.3h5.8V3L8.7 6l-.2.2-4.5.3-.2.1-.1.3c0 .2.1.4.3.4l4.5-.4c.2 0 .5 0 .6-.2l.4-.6.5-2.8c0-.4 0-.7-.3-.9m-6 7.3c-.4 0-.7.3-.7.7 0 .4.3.7.7.7.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7m4.6 0c-.4 0-.7.3-.7.7 0 .4.3.7.7.7.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7\"/>     <path d=\"M8 8H3l-.3-.3-.5-4.2-.3-2c0-.4-.5-.9-1-.9H.4c-.2 0-.4.2-.4.5 0 .2.2.4.4.4h.4c.1 0 .2 0 .2.2l.3 2L2 7.8c0 .5.5 1 1 1h5.2c.2 0 .3-.2.3-.5 0-.2-.1-.4-.3-.4\"/>   </g>"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-shopping-cart.svg
// module id = 628
// module chunks = 0